import { render, staticRenderFns } from "./ShipmentCombineDialog.vue?vue&type=template&id=1a904f28"
import script from "./ShipmentCombineDialog.vue?vue&type=script&lang=js"
export * from "./ShipmentCombineDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports